import { render, staticRenderFns } from "./RegisterProject.vue?vue&type=template&id=2c8c4b0f&scoped=true"
import script from "./RegisterProject.vue?vue&type=script&lang=js"
export * from "./RegisterProject.vue?vue&type=script&lang=js"
import style0 from "./RegisterProject.vue?vue&type=style&index=0&id=2c8c4b0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8c4b0f",
  null
  
)

export default component.exports